import { PAGE_IDS } from '@/constants/pages';
import { tw } from '@/lib/tailwind';
import { PAGE_ID } from '@/types/navigation';
import { IconType } from './CreateItem/CreateItem';
import CreateItem from './CreateItem/CreateItem';

interface CreatePopoverProps {
  isVisible: boolean;
  toggleCallback: () => void;
  htmlRef?: React.RefObject<HTMLDialogElement | null>;
}

export function CreatePopover({ isVisible, toggleCallback, htmlRef }: CreatePopoverProps) {
  const popOverItems: { title: string; description: string; icon: IconType; link: PAGE_ID | string }[] = [
    {
      title: 'Chart',
      description: 'Visualize data from your surveys as a chart, KPI, or table',
      icon: 'chart',
      link: PAGE_IDS.Search,
    },
    {
      title: 'Dashboard',
      description: 'Gather charts from across your organization into one view',
      icon: 'grid',
      link: PAGE_IDS.Dashboards,
    },
    {
      title: 'Dataset',
      description: 'Browse surveys and add their data to datasets for use in charts, searches, and dashboards',
      icon: 'table',
      link: PAGE_IDS.Datasets,
    },
  ];
  return (
    <dialog
      id="create-dialog"
      aria-label="Create Menu"
      ref={htmlRef}
      className={tw(
        `absolute top-10 right-0 left-auto z-30`,
        `w-90 bg-white p-1`,
        `border-border shadow-table flex flex-col rounded-md border border-solid`,
        isVisible && 'visible opacity-100',
        !isVisible && 'invisible opacity-0',
      )}
    >
      {popOverItems.map((item) => (
        <CreateItem
          key={item.link}
          title={item.title}
          description={item.description}
          icon={item.icon}
          link={item.link}
          toggleCallback={toggleCallback}
        />
      ))}
    </dialog>
  );
}
